import React from 'react';
import { Container, VStack, Box, Text, HStack } from '@chakra-ui/react';

const AuthLayout = ({ children, title }) => {
  return (
    <Container maxW="container.sm" py={10}>
      <VStack spacing={8}>
        <VStack spacing={4}>
          <Box width="150px" height="40px">
            <img src="/logo.png" alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          </Box>
          <Text fontSize="2xl" fontWeight="bold">{title}</Text>
        </VStack>
        <Box w="100%" p={8} borderWidth={1} borderRadius={8} boxShadow="lg">
          {children}
        </Box>
      </VStack>
    </Container>
  );
};

export default AuthLayout;
